import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export const useEvaluationFormsFeatureAvailability = () => {
  const { featureAvailability } = useFeatureAvailability(Features.ats_evaluation_forms)

  return hasFeature('dev_packaging_paywalls')
    ? featureAvailability.available
    : hasFeature('ats_evaluation_forms')
}
